import { render } from "./DataCards.vue?vue&type=template&id=584e2f1a&scoped=true"
import script from "./DataCards.vue?vue&type=script&lang=js"
export * from "./DataCards.vue?vue&type=script&lang=js"

import "./DataCards.vue?vue&type=style&index=0&id=584e2f1a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-584e2f1a"

export default script